var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Switch, styled } from '@mui/material';
var StyledSwitch = styled(Switch)(function (_a) {
    var theme = _a.theme;
    return ({
        width: 36,
        height: 20,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#FFFFFF',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    border: 0,
                },
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.3,
                cursor: "default",
            },
        },
        '& .MuiSwitch-thumb': {
            width: 16,
            height: 16,
            backgroundColor: '#FFFFFF',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            marginBottom: 25
        },
        '& .MuiSwitch-track': {
            borderRadius: 10,
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 300,
            }),
        },
    });
});
export var CustomSwitch = function (_a) {
    var activeColor = _a.activeColor, inactiveColor = _a.inactiveColor, thumbColor = _a.thumbColor, props = __rest(_a, ["activeColor", "inactiveColor", "thumbColor"]);
    return (React.createElement(StyledSwitch, __assign({}, props, { sx: __assign({ '& .MuiSwitch-switchBase.Mui-checked': {
                '& + .MuiSwitch-track': {
                    backgroundColor: activeColor || '#0D9489',
                },
            }, '& .MuiSwitch-track': {
                backgroundColor: props.checked
                    ? activeColor || '#0D9489'
                    : inactiveColor || '#DADADA',
            }, '& .MuiSwitch-thumb': {
                backgroundColor: thumbColor || '#FFFFFF',
            } }, props.sx) })));
};
export default CustomSwitch;
